import { createContext } from 'react';
import { BandwidthContextType } from './types';

export const BandwidthContext = createContext<BandwidthContextType>({
  status: 'offline',
  setStatus: () => {},
} as BandwidthContextType);
